import { Avatar, Breadcrumb } from "antd";
import MainLayout from "../../layouts/layout";
import "leaflet/dist/leaflet.css";
import "./viewProfile.scss";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";

const ViewProfile = () => {
  const [t] = useTranslation("global");

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const position = [51.505, -0.09];

  return (
    <>
      <div className="container-main container-profile">
        <div className="holder-top-of-page-content">
          <div className="g-hold-title-of-page">
            <Breadcrumb
              className="breadcrumbs"
              items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("acounts.viiewProfile.title") }]}
            />
            <div className="title-page">
              <h3>{t("acounts.viiewProfile.title")}</h3>
              <p></p>
            </div>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main profile-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="holder-view-profile">
                  <div className="profile-top">
                    <div className="holder-profile-pic">
                      <Avatar className="avatar" size={90} gap={10}>
                        <i className="icon-user"></i>
                      </Avatar>
                    </div>
                    <div className="holder-profile-person">
                      <h3>{_currentUser?.firstname + " " + _currentUser?.lastname}</h3>
                      <ul>
                        <li>
                          <div className="label">کد شعبه: </div>
                          <div className="value">
                            <span dir="ltr">{_currentUser?.branchcode}</span>
                          </div>
                        </li>
                        <li>
                          <div className="label">نام کاربری:</div>
                          <div className="value">
                            <span dir="ltr">{_currentUser?.username}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="holder-body-profile">
                    <div className="holder-list-item">
                      <ul>
                        <li>
                          <div className="label">
                            <i className="icon-cell-phone"></i>
                            تلفن همراه: <span dir="ltr"> 0{_currentUser?.telnoone}</span>
                          </div>
                        </li>
                        <li>
                          <div className="label">
                            <i className="icon-phone"></i>
                            تلفن ثابت: <span dir="ltr"> 0{_currentUser?.telnotwo}</span>
                          </div>
                        </li>
                        <li>
                          <div className="label">
                            <i className="icon-location"></i>
                            آدرس: <span>{_currentUser?.address}</span>
                          </div>
                        </li>
                        <li>
                          <div className="label">
                            <i className="icon-post-box"></i>
                            کدپستی: <span dir="ltr">{_currentUser?.postalcode}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="holder-share-location" style={{ position: "relative", overflow: "hidden", height: "300px" }}>
                      <MapContainer center={position} zoom={13} scrollWheelZoom={false}>
                        <TileLayer attribution="" url="" />
                        <Marker position={position}>
                          <Popup>
                            A pretty CSS3 popup. <br /> Easily customizable.
                          </Popup>
                        </Marker>
                      </MapContainer>
                      ,{/* [(_currentUser?.lat, _currentUser?.lng)] */}
                      {/* <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={false}>
                        <TileLayer
                          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={[51.505, -0.09]}>
                          <Popup>
                            A pretty CSS3 popup. <br /> Easily customizable.
                          </Popup>
                        </Marker>
                      </MapContainer> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </div>
    </>
  );
};

export default ViewProfile;
